import { STATUS_NULL_FILTER } from '@seller-area/components/molecules/company-details/unit-details-drawer/constants';

import { ClientsReportFilters } from './types';

export const buildClientsReportFilterFields = (filters: ClientsReportFilters) => ({
  term: filters.term || undefined,
  nameFilter: filters.nameFilter || undefined,
  legalNameFilter: filters.legalNameFilter || undefined,
  accountManagerIdFilter: filters.accountManagerIdFilter || undefined,
  docTypeFilter: filters.docType ?? undefined,
  docNumberFilter: filters.docNumberFilter || undefined,
  companyIdFilter: filters.companyIdFilter || undefined,
  clientIdFilter: filters.clientIdFilter || undefined,
  status: filters.status && filters.status !== STATUS_NULL_FILTER ? filters.status : undefined,
  statusIsNull: filters.status === STATUS_NULL_FILTER ? true : undefined,
  companyType: filters.type ?? undefined,
  exposure: filters.exposure ?? undefined,
  volumeMwmMin: filters.volumeMwmRange?.min ?? undefined,
  volumeMwmMax: filters.volumeMwmRange?.max ?? undefined,
  exposurePercentageMin: filters.exposurePercentageRange?.min ?? undefined,
  exposurePercentageMax: filters.exposurePercentageRange?.max ?? undefined,
  unitsCountMin: filters.unitsCountRange?.min ?? undefined,
  unitsCountMax: filters.unitsCountRange?.max ?? undefined,
  clientSinceFrom: filters.clientSinceRange?.from ?? undefined,
  clientSinceTo: filters.clientSinceRange?.to ?? undefined,
  churnDateFrom: filters.churnDateRange?.from ?? undefined,
  churnDateTo: filters.churnDateRange?.to ?? undefined,
  createdAtFrom: filters.createdAtRange?.from ?? undefined,
  createdAtTo: filters.createdAtRange?.to ?? undefined,
  updatedAtFrom: filters.updatedAtRange?.from ?? undefined,
  updatedAtTo: filters.updatedAtRange?.to ?? undefined,
});

export const buildClientsReportGraphqlVariables = (
  page: number,
  limit: number,
  filters: ClientsReportFilters,
  sortBy: string | null,
  sortOrder: 'asc' | 'desc',
  nullKpi: string | null = null,
) => ({
  page,
  limit,
  ...buildClientsReportFilterFields(filters),
  sortBy: sortBy ?? undefined,
  sortOrder: sortBy ? sortOrder : undefined,
  nullKpi: nullKpi ?? undefined,
});

const EXPORT_PARAM_KEYS: Record<string, string> = {
  term: 'term',
  nameFilter: 'name_filter',
  legalNameFilter: 'legal_name_filter',
  accountManagerIdFilter: 'account_manager_id_filter',
  docTypeFilter: 'doc_type_filter',
  docNumberFilter: 'doc_number_filter',
  companyIdFilter: 'company_id_filter',
  clientIdFilter: 'client_id_filter',
  status: 'status',
  statusIsNull: 'status_is_null',
  companyType: 'company_type',
  exposure: 'exposure',
  volumeMwmMin: 'volume_mwm_min',
  volumeMwmMax: 'volume_mwm_max',
  exposurePercentageMin: 'exposure_percentage_min',
  exposurePercentageMax: 'exposure_percentage_max',
  unitsCountMin: 'units_count_min',
  unitsCountMax: 'units_count_max',
  clientSinceFrom: 'client_since_from',
  clientSinceTo: 'client_since_to',
  churnDateFrom: 'churn_date_from',
  churnDateTo: 'churn_date_to',
  createdAtFrom: 'created_at_from',
  createdAtTo: 'created_at_to',
  updatedAtFrom: 'updated_at_from',
  updatedAtTo: 'updated_at_to',
};

export const appendClientsReportExportParams = (
  params: URLSearchParams,
  filters: ClientsReportFilters,
  nullKpi: string | null = null,
) => {
  const fields = buildClientsReportFilterFields(filters);

  Object.entries(EXPORT_PARAM_KEYS).forEach(([sourceKey, targetKey]) => {
    const value = fields[sourceKey as keyof typeof fields];
    if (value == null || value === '') return;
    params.append(targetKey, String(value));
  });

  if (nullKpi) {
    params.append('null_kpi', nullKpi);
  }
};
